<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Sincronização de Inventário">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
                <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <!--
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                -->
                <b-button variant="github" class="mr-1 btn-brand" @click="forceSync()"><i class="fa fa-plus"></i><span>Sincronizar</span></b-button>
                
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    @change="changeCompany"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
             <b-form-group>
                <label for="inventory" style="font-size: 0.8em">Inventário</label>
                <b-form-select id="inventory"
                  v-model="filters.inventoryId"
                  :plain="true"
                  :options="inventoryDDL"
                  :value="[null,'c']"
                  @change="refreshData()"
                  >
                </b-form-select>
            </b-form-group>
          
          </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="labelFilter" style="font-size: 0.8em">Etiqueta</label>
                  <b-form-input v-model="filters.label" type="text" id="labelFilter" placeholder="Etiqueta"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>


            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Status</label>
                  <b-form-select id="status"
                    v-model="filters.statusId"
                    :plain="true"
                    :options="selectInventoryStatusDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>
  
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>

          <b-row class="mb-3">
            <b-col>
              <div class="d-flex align-items-center">
                <span class="text-muted">
                  <strong>Total:</strong> {{ items.length }} sincronizações
                  <span v-if="filteredItems.length !== items.length"> | <strong>Filtrados:</strong> {{ filteredItems.length }}</span>
                </span>
                <b-spinner small variant="primary" class="ml-2" v-if="isLoadingMore"></b-spinner>
                <span v-if="isLoadingMore" class="text-primary ml-1" style="font-size: 0.9em">Carregando mais...</span>
              </div>
            </b-col>
          </b-row>

            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped

                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row>
                            <b-col class="small text-right" md="1">Produto: </b-col>
                            <b-col>{{ row.item.product.code }} - {{ row.item.product.description }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="small text-right" md="1">Contador: </b-col>
                            <b-col>{{ row.item.user.name }}</b-col>
                        </b-row>
                        
                    </b-card>
                </template>
                
                <template v-slot:cell(originalValue)="data">
                    {{ !isNaN(data.item.originalValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.originalValue) : '' }}
                </template>
  
                <template v-slot:cell(paymentValue)="data">
                    {{ !isNaN(data.item.paymentValue) ? new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format( data.item.paymentValue) : '' }}
                </template>
  
                <template v-slot:cell(product)="data">
                    <div v-if="data.item.product">
                      {{ data.item.product.code  }}<br><span class="primary">{{ data.item.product.description }}</span>
                    </div>
                </template>
  
                <template v-slot:cell(countDate)="data">
                    {{ $utils.localDateTime( data.item.countDate ) }}
                </template>

                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" />
                </template>

                <template v-slot:cell(action)="data">
                    <b-button size="sm" variant="danger" v-if="data.item.statusId == 4" :disabled="reprocessingId === data.item.id" @click.stop="reprocessItem(data.item)" title="Tentar Reprocessar" class="btn-brand">
                      <b-spinner small v-if="reprocessingId === data.item.id"></b-spinner>
                      <i class="fa fa-refresh" v-else></i>
                    </b-button>
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Sincronização"
              size="lg">
  
        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">
      
        
          <b-row>
            <b-col md="12">
              <b-form>
                <textarea v-model="this.selectedItem.history" class="form-control" id="message" name="body" rows="8" readonly></textarea>
              </b-form>
            </b-col>
          </b-row>
  
  
          <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
          <div slot="footer" class="text-right">
            <!--
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
            <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
            -->
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Dispositivo</span></b-button>
           
          </div>
                
        </div>
        </b-form>
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch
    },
    data: () => {
      return {
        inventoryDDL: null,
        inventoryStatusDDL: [],
        companyDDL: [],
        reprocessingId: null,
  
        isBusy: false,
        isLoadingMore: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          companyId: null,
          key: '',
          label: '',
          inventoryId: 0,
          statusId: 0
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          {key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
          //{key: 'name', label: 'Dispositivo', sortable: true },
          //{key: 'areaCode', label: 'Área', sortable: true, thStyle: { width: "100px" } },
          //{key: 'nro', label: 'Nro', sortable: true, thStyle: { width: "100px" } },
          //{key: 'code', label: 'Código/Mac Address', sortable: true },
          //{key: 'company.alias', label: 'Empresa', sortable: true, thStyle: { width: "30px" }, class: 'text-center'  },
          {key: 'label', label: 'Etiqueta', sortable: true, thStyle: { width: "100px" }, class: 'text-center' },
          {key: 'product', label: 'Item', sortable: true },
          {key: 'locationName', label: 'Setor', sortable: true, class: 'text-center', thStyle: { width: "80px" } },
          {key: 'operationCode', label: 'Op', sortable: true, thStyle: { width: "30px" }, class: 'text-center'  },
          {key: 'count', label: 'Contagem', sortable: true, thStyle: { width: "80px" }, class: 'text-center'  },
          {key: 'countDate', label: 'Data', sortable: true, thStyle: { width: "110px" }, class: 'text-center'  },
          {key: 'user.username', label: 'Usuário', sortable: true, thStyle: { width: "80px" }, class: 'text-center' },
          


          //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
          //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          //{key: 'description', label: 'Descrição', sortable: false },
          //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
          {key: 'statusName', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "150px" } },
          {key: 'action', label: '', sortable: false, thStyle: { width: "60px" } }
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      selectInventoryStatusDDL: function() {
          var list = [...this.inventoryStatusDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '- Todos -' })
          return list
      },
      totalRows: function () { return this.filteredItems.length },
      filteredItems() {
        try {
            var s = this;
            // Compara apenas os dígitos, ignorando zeros à esquerda (ex.: "4" encontra "00004")
            var labelFilterDigits = s.$utils.numbersOnly(s.filters.label || '');

            return this.items.filter(item => {
              return (this.filters.key == '' || (
                  item.product && (
                    this.$utils.filterString(item.product.description, this.filters.key)
                    || item.product.code == this.filters.key
                  )
                  //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  ))
                  && (labelFilterDigits == '' || Number(s.$utils.numbersOnly(item.label)) === Number(labelFilterDigits))
                  && (this.filters.statusId==0 || ( this.filters.statusId == item.statusId ))
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    watch: {
      filteredItems() {
        var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
        if (this.currentPage > totalPages) {
          this.currentPage = 1;
        }
      },
      perPage() {
        var totalPages = Math.ceil(this.filteredItems.length / this.perPage) || 1;
        if (this.currentPage > totalPages) {
          this.currentPage = 1;
        }
      }
    },
    methods: {


      async saveItem(currentItem) {
  
        var s = this;
        var postData = {...currentItem};
  
        postData["companyId"] = s.filters.companyId
        postData["uid"] = this.$store.state.currentUser.id
        postData["sid"] = this.$store.state.currentUser.sid
  
        await axios.post(
            this.$store.state.ws_url + "/sys/device",
            postData
        ).then(function() {
            s.closeEditModal()
            s.refreshData();
        }
        ).catch(function (error) {
            console.log(error);
  
            toast ({
                type: VueNotifications.types.warn,
                title: 'Erro',
                message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                timeout: 5000
            })        
        });
  
    },
  
    save() {
  
        let msgError = [];
  
        if(this.selectedItem.code.length <= 2)
            msgError.push("Código/Mac Address");
        
        if(msgError.length > 0) {
            let msgErrorExt = "Verifique os campos: ";
            let msgErrorSep = "";
            msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )
  
            toast ({
                type: VueNotifications.types.error,
                title: 'Erro',
                message: msgErrorExt,
                timeout: 5000
            })
        }
        else {
            this.saveItem(this.selectedItem);
        }
    },
  
      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = { ...newItem };      
        }
        else {
            this.selectedItem = { ...item };
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items       
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
       
            this.clearSelectedRows();
            this.openEditModal(item);
    
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },

      async reprocessItem(item) {
        var s = this;
        var currentUser = this.$store.state.currentUser;

        this.reprocessingId = item.id;

        await axios.get(
              this.$store.state.ws_url + "/inventory/sync/reprocess?inventorySyncId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {
              toast ({
                      type: resp.data.code > 0 ? VueNotifications.types.info : VueNotifications.types.warn,
                      title: 'Reprocessar',
                      message: resp.data.message,
                      timeout: 5000
                  })
              s.refreshData();
        })
        .catch(function(error) {
            console.log(error);
            toast ({
                      type: VueNotifications.types.error,
                      title: 'Reprocessar',
                      message: error.response && error.response.data && error.response.data.message ? error.response.data.message : "Erro ao reprocessar.",
                      timeout: 5000
                  })
        });

        this.reprocessingId = null;
      },

      async forceSync() {
        var s = this;
        var currentUser = this.$store.state.currentUser;

        await axios.get(
              this.$store.state.ws_url + "/inventory/sync/reprocessall?inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

        ).then(function(resp) {
              s.refreshData();
              toast ({
                      type: VueNotifications.types.info,
                      title: 'Sincronizar',
                      message: 'Contagens sincronizadas.',
                      timeout: 3000
                  })
        })            
        .catch(function(error) {
            console.log(error);
            toast ({
                      type: VueNotifications.types.error,
                      title: 'Sincronizar',
                      message: error.response && error.response.data && error.response.data.message ? error.response.data.message : "Erro ao sincronizar.",
                      timeout: 3000
                  })
        });

      
      },

      async getStatus() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          
          await axios.get(
              this.$store.state.ws_url + "/inventory/sync/status/ddl?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {
              s.inventoryStatusDDL = resp.data.obj;
          })            
          .catch(function(error) {
              console.log(error);
          });

          
      }, 

      async getInventory() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          
          await axios.get(
              this.$store.state.ws_url + "/stock/inventory/ddl?companyId=" + s.filters.companyId + "&inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {
              s.inventoryDDL = resp.data.obj;

              if(s.inventoryDDL && s.inventoryDDL.length > 0) {
                if(!s.filters.inventoryId || !s.inventoryDDL.some(i => i.value == s.filters.inventoryId)) {
                  s.filters.inventoryId = Number(s.inventoryDDL[s.inventoryDDL.length-1].value)
                }
                s.$utils.setInventoryContext(s.$store.state.config.storageName, s.filters.companyId, s.filters.inventoryId)
                s.refreshData();
              }
          })
          .catch(function(error) {
              console.log(error);
          });

          
      }, 
      async refreshData() {
        if (!this.filters.inventoryId) {
          return;
        }

        this.$utils.setInventoryContext(this.$store.state.config.storageName, this.filters.companyId, this.filters.inventoryId)

        this.isBusy = true;
        this.isLoadingMore = false;

        var s = this;
        var currentUser = this.$store.state.currentUser;
        var page = 1;
        var pageSize = 100;
        var allItems = [];
        var hasMoreData = true;

        while (hasMoreData) {
          var url = this.$store.state.ws_url + "/inventory/sync?companyId=" + s.filters.companyId + "&inventoryId=" + s.filters.inventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid + "&page=" + page + "&pageSize=" + pageSize;
          try {
            var resp = await axios.get(url);

            if (resp.data.obj && resp.data.obj.length > 0) {
              allItems = allItems.concat(resp.data.obj);

              // Atualiza a tabela com os dados carregados até o momento
              s.items = [...allItems];

              // Remove o loading após carregar a primeira página
              if (page === 1) {
                s.isBusy = false;
                // Se há mais páginas, mostra o spinner de loading adicional
                if (resp.data.obj.length === pageSize) {
                  s.isLoadingMore = true;
                }
              }

              // Se retornou menos itens que o pageSize, não há mais páginas
              if (resp.data.obj.length < pageSize) {
                hasMoreData = false;
              } else {
                page++;
              }
            } else {
              // Sem mais dados
              hasMoreData = false;
            }
          } catch (error) {
            hasMoreData = false;
            toast({
              type: VueNotifications.types.error,
              title: 'Erro',
              message: 'Sem permissão de acesso. Verifique e tente novamente.',
              timeout: 3000
            });
          }
        }

        this.isBusy = false;
        this.isLoadingMore = false;
      },

      changeCompany() {
        this.getStatus();
        this.getInventory();
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies

      var stored = this.$utils.getInventoryContext(this.$store.state.config.storageName)
      var validStoredCompany = stored && stored.companyId && this.companyDDL.some(c => c.value == stored.companyId)

      this.filters.companyId = validStoredCompany ? stored.companyId : this.$store.state.currentUser.companyId
      if(validStoredCompany && stored.inventoryId) {
        this.filters.inventoryId = stored.inventoryId
      }

      this.changeCompany()
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>